import { validatePhoneNumber } from '@shared/ui/fields/phone-field/utils';
import type { SuperValidated } from 'sveltekit-superforms';
import { z } from 'zod';

const phoneCheck = z.custom<string>((number) => {
  return typeof number === 'string' && validatePhoneNumber(number);
}, 'Phone is not valid');

const majorType = z.enum(
  ['gallery', 'art_institution', 'artist', 'tech-expert', 'collector', 'photographer', 'partner', 'adviser', 'other'],
  {
    required_error: 'This field is required',
  },
);

export type PersonType = z.infer<typeof majorType>;
export type FirstStepContactForm = SuperValidated<typeof firstStepContactForm>;

export const firstStepContactForm = z.object({
  major: majorType,
  full_name: z.string().min(1, 'Name is required').max(124),
  email: z.string().min(1, 'Email is required').trim().email('The e-mail address entered is invalid.'),
  phone: phoneCheck.default(''),
});
